// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"98c7203f","950":"729d7941"}[chunkId] + ".chunk.css";
};